<ng-container
  *ngIf="generalInformationResource$ | async as generalInformationResource"
>
  <ng-container *ngIf="validationResource$ | async as validationResource">
    <div id="ch-ggs-web-suite-content">
      <div id="input" class="container">
        <h1>{{ generalInformationResource['HeadingTitle'] }}</h1>
        <div class="row">
          <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <p>{{ generalInformationResource['Paragraph1'] }}</p>

            <ng-container *ngIf="!hideDocumentLoadFunctionality">
              <h3>
                {{ generalInformationResource['TitleShippingPaperActions'] }}
              </h3>
              <hazmatsuite-next-license-dependent-button
                [model]="licenseBtnModel"
                [title]="generalInformationResource['ButtonOpenShippingPaper']"
                (submitAction)="openDocumentsModal()"
              ></hazmatsuite-next-license-dependent-button>
              <hr />
            </ng-container>

            <form [formGroup]="formGroup">
              <div class="form-group">
                <label for="name" class="h4">{{
                  generalInformationResource['ShippingPaperName']
                }}</label>
                <input
                  id="name"
                  type="text"
                  class="form-control"
                  formControlName="name"
                />
                <div class="validation">
                  <span
                    *ngIf="name?.invalid && (name?.dirty || name?.touched)"
                    class="text-danger"
                  >
                    {{ validationResource['InputRequired'] }}
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="description">{{
                  generalInformationResource['ShippingPaperDescription']
                }}</label>
                <textarea
                  id="description"
                  class="form-control"
                  formControlName="description"
                ></textarea>
              </div>

              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="shipper" class="h4">{{
                      generalInformationResource['Sender']
                    }}</label>
                    <textarea
                      id="shipper"
                      class="form-control"
                      formControlName="shipper"
                      rows="6"
                      [placeholder]="
                        generalInformationResource['PlaceholderShipper']
                      "
                    ></textarea>
                    <div class="validation">
                      <span
                        *ngIf="
                          shipper?.invalid &&
                          (shipper?.dirty || shipper?.touched)
                        "
                        class="text-danger"
                      >
                        {{ validationResource['InputRequired'] }}
                      </span>
                    </div>
                  </div>

                  <div class="form-group">
                    <hazmatsuite-next-license-dependent-button
                      [model]="addressLicenseBtnModel"
                      [title]="
                        generalInformationResource[
                          'ButtonShipperFromAddressBook'
                        ]
                      "
                      (beforeNavigationAction)="enableStepHistory()"
                      (submitAction)="
                        navigateToAddressList(addressTypes.shipper)
                      "
                    ></hazmatsuite-next-license-dependent-button>
                    <!-- @await Html.PartialAsync("_LicenseDependentButton", new LicenseDependentButtonViewModel
                          {
                              ButtonLabel = GeneralInformationResource.ButtonShipperFromAddressBook,
                              ButtonIcon = "ifc-custom ifc-book",
                              LinkUrl = $"/{CultureService.GetCurrentCulture()}/{Constants.EasyDgdAreaName}/{AddressListController.GetControllerName()}/{nameof(AddressListController.Shipper)}",
                          }) -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="consignee" class="h4">{{
                      generalInformationResource['Consignee']
                    }}</label>
                    <textarea
                      id="consignee"
                      class="form-control"
                      formControlName="consignee"
                      rows="6"
                      [placeholder]="
                        generalInformationResource['PlaceholderConsignee']
                      "
                    ></textarea>
                    <div class="validation">
                      <span
                        *ngIf="
                          consignee?.invalid &&
                          (consignee?.dirty || consignee?.touched)
                        "
                        class="text-danger"
                      >
                        {{ validationResource['InputRequired'] }}
                      </span>
                    </div>
                  </div>

                  <div class="form-group">
                    <hazmatsuite-next-license-dependent-button
                      [model]="addressLicenseBtnModel"
                      [title]="
                        generalInformationResource[
                          'ButtonConsigneeFromAddressBook'
                        ]
                      "
                      (beforeNavigationAction)="enableStepHistory()"
                      (submitAction)="
                        navigateToAddressList(addressTypes.consignee)
                      "
                    ></hazmatsuite-next-license-dependent-button>
                    <!-- @await Html.PartialAsync("_LicenseDependentButton", new LicenseDependentButtonViewModel
                        {
                            ButtonLabel = GeneralInformationResource.ButtonConsigneeFromAddressBook,
                            ButtonIcon = "ifc-custom ifc-book",
                            LinkUrl = $"/{CultureService.GetCurrentCulture()}/{Constants.EasyDgdAreaName}/{AddressListController.GetControllerName()}/{nameof(AddressListController.Consignee)}",
                        }) -->
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="reference">{{
                  generalInformationResource['Reference']
                }}</label>
                <input
                  type="text"
                  id="reference"
                  class="form-control"
                  formControlName="reference"
                />
              </div>

              <div class="form-group">
                <label for="additionalhandlinginformation">{{
                  generalInformationResource['AdditionalHandlingInformation']
                }}</label>
                <input
                  type="text"
                  id="additionalhandlinginformation"
                  class="form-control"
                  formControlName="additionalhandlinginformation"
                />
              </div>

              <ng-container *ngIf="transportMode === transportModes.Sea">
                <div class="form-group">
                  <label for="portofdeparture">{{
                    generalInformationResource['SeaPortOfDeparture']
                  }}</label>
                  <input
                    type="text"
                    id="portofdeparture"
                    class="form-control"
                    formControlName="portofdeparture"
                  />
                </div>
                <div class="form-group">
                  <label for="portofdestination">{{
                    generalInformationResource['SeaPortOfDestination']
                  }}</label>
                  <input
                    type="text"
                    id="portofdestination"
                    class="form-control"
                    formControlName="portofdestination"
                  />
                </div>

                <div class="form-group">
                  <label for="emergencyTelephoneNumber">{{
                    generalInformationResource['EmergencyTelephoneNumber']
                  }}</label>
                  <input
                    type="text"
                    id="emergencyTelephoneNumber"
                    class="form-control"
                    formControlName="emergencyTelephoneNumber"
                  />
                </div>
                <div class="form-group">
                  <!-- @($"/{CultureService.GetCurrentCulture()}/{Constants.EasyDgdAreaName}/{GeneralInformationController.GetControllerName()}/{nameof(GeneralInformationController.Emtel)}") -->
                  <!-- <a href="" class="btn btn-iconed btn-iconed-primary btn-iconed-left" target="_blank">24h Notfallnummer kaufen <i class="btn-icon ifc-custom ifc-phone" aria-hidden="true"></i></a> -->
                </div>

                <div class="form-group">
                  <label for="signatoryName" class="h4">{{
                    generalInformationResource['SignatoryName']
                  }}</label>
                  <input
                    id="signatoryName"
                    type="text"
                    class="form-control"
                    formControlName="signatoryName"
                  />
                  <div class="validation">
                    <span
                      *ngIf="
                        signatoryName?.invalid &&
                        (signatoryName?.dirty || signatoryName?.touched)
                      "
                      class="text-danger"
                    >
                      {{ validationResource['InputRequired'] }}
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="signatoryTitle">{{
                    generalInformationResource['SignatoryTitle']
                  }}</label>
                  <input
                    id="signatoryTitle"
                    type="text"
                    class="form-control"
                    formControlName="signatoryTitle"
                  />
                </div>

                <div class="form-group">
                  <label for="signatoryPlace" class="h4">{{
                    generalInformationResource['SignatoryPlace']
                  }}</label>
                  <input
                    id="signatoryPlace"
                    type="text"
                    class="form-control"
                    formControlName="signatoryPlace"
                  />
                  <div class="validation">
                    <span
                      *ngIf="
                        signatoryPlace?.invalid &&
                        (signatoryPlace?.dirty || signatoryPlace?.touched)
                      "
                      class="text-danger"
                    >
                      {{ validationResource['InputRequired'] }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="transportMode === transportModes.Air">
                <div class="form-group">
                  <label for="airWayBill">{{
                    generalInformationResource['AirWayBill']
                  }}</label>
                  <input
                    type="text"
                    id="airWayBill"
                    class="form-control"
                    formControlName="airWayBill"
                  />
                </div>
                <div class="form-group">
                  <label for="airPortFrom">{{
                    generalInformationResource['AirPortOfDeparture']
                  }}</label>
                  <input
                    type="text"
                    id="airPortFrom"
                    class="form-control"
                    formControlName="portofdeparture"
                  />
                </div>
                <div class="form-group">
                  <label for="airPortTo">{{
                    generalInformationResource['AirPortOfDestination']
                  }}</label>
                  <input
                    type="text"
                    id="airPortTo"
                    class="form-control"
                    formControlName="portofdestination"
                  />
                </div>

                <div class="form-group">
                  <label for="emergencyTelephoneNumber">{{
                    generalInformationResource['EmergencyTelephoneNumber']
                  }}</label>
                  <input
                    type="text"
                    id="emergencyTelephoneNumber"
                    class="form-control"
                    formControlName="emergencyTelephoneNumber"
                  />
                </div>
                <div class="form-group">
                  <!-- @($"/{CultureService.GetCurrentCulture()}/{Constants.EasyDgdAreaName}/{GeneralInformationController.GetControllerName()}/{nameof(GeneralInformationController.Emtel)}") -->
                  <!-- <a href="" class="btn btn-iconed btn-iconed-primary btn-iconed-left" target="_blank">24h Notfallnummer kaufen <i class="btn-icon ifc-custom ifc-phone" aria-hidden="true"></i></a> -->
                </div>

                <div class="form-group row">
                  <div class="col-sm-9">
                    <div class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input check-box"
                        formControlName="originalReceivedElectronically"
                      />
                      <label class="col-sm-9 form-check-label">{{
                        generalInformationResource[
                          'OriginalReceivedElectronically'
                        ]
                      }}</label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="signatoryName" class="h4">{{
                    generalInformationResource['SignatoryName']
                  }}</label>
                  <input
                    id="signatoryName"
                    type="text"
                    class="form-control"
                    formControlName="signatoryName"
                  />
                  <div class="validation">
                    <span
                      *ngIf="
                        signatoryName?.invalid &&
                        (signatoryName?.dirty || signatoryName?.touched)
                      "
                      class="text-danger"
                    >
                      {{ validationResource['InputRequired'] }}
                    </span>
                  </div>
                </div>
              </ng-container>

              <div class="form-group">
                <label>{{ generalInformationResource['ShippingDate'] }}</label>
                <div class="form-group row">
                  <div class="col-sm-3">
                    <ejs-datepicker
                      formControlName="shippingDate"
                      format="dd.MM.yyyy"
                    ></ejs-datepicker>
                  </div>
                  <div class="col-sm-9">
                    <label for="isShippingDateUnknown">{{
                      generalInformationResource['IsShippingDateUnknown']
                    }}</label>
                    <input
                      class="ml-2"
                      formControlName="isShippingDateUnknown"
                      id="isShippingDateUnknown"
                      type="checkbox"
                      (change)="changeShippingDateUnknown($event)"
                    />
                  </div>
                  <div class="validation col-12">
                    <span
                      *ngIf="
                        shippingDate?.invalid &&
                        (shippingDate?.dirty || shippingDate?.touched)
                      "
                      class="text-danger"
                    >
                      {{ validationResource['InputRequired'] }}
                    </span>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="transportMode === transportModes.Sea">
                <hazmatsuite-next-accordion>
                  <div slot="header">
                    {{ generalInformationResource['H4Title1'] }}
                  </div>
                  <div slot="body">
                    <div class="form-group">
                      <label for="vehicleId">{{
                        generalInformationResource[
                          'ContainerVehicleIdentification'
                        ]
                      }}</label>
                      <input
                        id="vehicleId"
                        type="text"
                        class="form-control"
                        formControlName="vehicleId"
                      />
                    </div>

                    <div class="form-group">
                      <label for="grossMass">{{
                        generalInformationResource['GrossMass']
                      }}</label>
                      <input
                        id="grossMass"
                        type="text"
                        class="form-control"
                        formControlName="grossMass"
                      />
                    </div>

                    <div class="form-group">
                      <label for="sealNumbers">{{
                        generalInformationResource['SealNumbers']
                      }}</label>
                      <input
                        id="sealNumbers"
                        type="text"
                        class="form-control"
                        formControlName="sealNumbers"
                      />
                    </div>

                    <div class="form-group">
                      <label for="packingCertificateSignatoryName">{{
                        generalInformationResource[
                          'PackingCertificateSignatoryName'
                        ]
                      }}</label>
                      <input
                        id="packingCertificateSignatoryName"
                        type="text"
                        class="form-control"
                        formControlName="packingCertificateSignatoryName"
                      />
                    </div>

                    <div class="form-group">
                      <label for="signatoryRole">{{
                        generalInformationResource['SignatoryRole']
                      }}</label>
                      <input
                        id="signatoryRole"
                        type="text"
                        class="form-control"
                        formControlName="signatoryRole"
                      />
                    </div>

                    <div class="form-group">
                      <label for="signatoryCompanyName">{{
                        generalInformationResource['SignatoryCompanyName']
                      }}</label>
                      <input
                        id="signatoryCompanyName"
                        type="text"
                        class="form-control"
                        formControlName="signatoryCompanyName"
                      />
                    </div>

                    <div class="form-group">
                      <label for="packingPlace">{{
                        generalInformationResource['PackingPlace']
                      }}</label>
                      <input
                        id="packingPlace"
                        type="text"
                        class="form-control"
                        formControlName="packingPlace"
                      />
                    </div>

                    <div class="form-group">
                      <label for="packingDate">{{
                        generalInformationResource['PackingDate']
                      }}</label>
                      <input
                        id="packingDate"
                        type="text"
                        class="form-control"
                        formControlName="packingDate"
                      />
                      <div>CHECKBOX: PAcking Date Unknown</div>
                    </div>
                  </div>
                </hazmatsuite-next-accordion>
              </ng-container>

              <div
                class="form-group"
                *ngIf="transportMode !== transportModes.Road"
              >
                <label for="isMultimodalTransportation">{{
                  generalInformationResource['IsMultimodalTransportation']
                }}</label>
                <input
                  id="isMultimodalTransportation"
                  type="checkbox"
                  class="ml-2"
                  formControlName="isMultimodalTransportation"
                />
              </div>

              <div id="dgd-form-navigation">
                <div class="row mt-sm-5 align-items-center">
                  <p class="col-sm-7 col-md-9 text-muted small mb-sm-0">
                    {{ generalInformationResource['Paragraph2'] }}
                  </p>
                </div>
                <easydgd-footer-navigation-buttons></easydgd-footer-navigation-buttons>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="addressListResource$ | async as addressListResource">
      <ng-container
        *ngIf="shippingPaperListResource$ | async as shippingPaperListResource"
      >
        <hazmatsuite-next-modal
          [title]="generalInformationResource['ButtonOpenShippingPaper']"
          [showModal]="documentsModalOpen"
          modalSize="xl"
          (closeModal)="documentsModalOpen = false"
        >
          <p *ngIf="!allDocuments.length">
            No ShippingPapers available to load
          </p>

          <table
            class="table table-striped table-bordered table-hover"
            *ngIf="allDocuments?.length"
          >
            <thead>
              <tr>
                <th scope="col">
                  {{ shippingPaperListResource['ListHeaderTextName'] }}
                </th>
                <th scope="col float-right">
                  {{ shippingPaperListResource['ListHeaderTextActions'] }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of currentItemList; trackBy: identify">
                <td>
                  {{ item.Name }}
                </td>
                <td class="align-right d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary mr-2"
                    (click)="editShippingPaper(item.Id)"
                  >
                    <i
                      class="ifc-custom ifc-pencil d-flex align-items-center justify-content-center"
                      aria-hidden="true"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mr-2"
                    (click)="cloneShippingPaper(item.Id)"
                  >
                    <i
                      class="ifc-custom ifc-copy d-flex align-items-center justify-content-center"
                      aria-hidden="true"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mr-2"
                    (click)="deleteShippingPaper(item.Id)"
                  >
                    <i
                      class="ifc-custom ifc-bin d-flex align-items-center justify-content-center"
                      aria-hidden="true"
                    ></i>
                  </button>
                </td>
              </tr>
              <tr class="table-active">
                <td colspan="1">
                  <div class="d-flex align-items-center pagination">
                    <span
                      class="action"
                      [class.disabled]="startIndex === 0"
                      (click)="goToFirstPage()"
                      >«</span
                    >
                    <span
                      class="action"
                      [class.disabled]="startIndex === 0"
                      (click)="goToPreviousPage()"
                      >&lt;</span
                    >
                    <span class="page-indicator"
                      ><strong>{{ pageIndex }}</strong></span
                    >
                    <span
                      class="action"
                      [class.disabled]="isLastPage"
                      (click)="goToNextPage()"
                      >&gt;</span
                    >
                    <span
                      class="action"
                      [class.disabled]="isLastPage"
                      (click)="goToLastPage()"
                      >»</span
                    >
                  </div>
                </td>
                <td colspan="1">
                  <span class="float-right"
                    >{{ shippingPaperListResource['Pages'] }}:
                    <strong>{{ pageIndex }}</strong
                    >/{{ totalPages }}
                    <i
                      >({{ currentPageEntries }}/{{ totalItems }}
                      {{ shippingPaperListResource['Entries'] }})</i
                    ></span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </hazmatsuite-next-modal>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="data$ | async"></ng-container>
</ng-container>
